// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import consultationSubmissionEntity from './entities/consultation-submission.json';
import consultationSubmissionMenu from '../pages/consultation-submission/menu.json';
import consultationSubmissionFullForm from '../pages/consultation-submission/forms/full.json';
import consultationSubmissionContextForm from '../pages/consultation-submission/forms/context.json';
import consultationSubmissionMiniForm from '../pages/consultation-submission/forms/mini.json';
import consultationSubmissionLookupForm from '../pages/consultation-submission/forms/lookup.json';
import consultationSubmissionTableView from '../pages/consultation-submission/views/table.json';
import consultationSubmissionCardsView from '../pages/consultation-submission/views/cards.json';
import consultationSubmissionDashboardView from '../pages/consultation-submission/views/dashboard.json';

/** Тип запису «Подання на консультацію» зі сторінками пакета: меню, форми та подання з pages/consultation-submission/. */
export const consultationSubmissionDefinition: IRecordTypeDefinition = {
  ...consultationSubmissionEntity,
  views: assembleViewSet({
      table: consultationSubmissionTableView,
      cards: consultationSubmissionCardsView,
      dashboard: consultationSubmissionDashboardView,
  }),
  form: consultationSubmissionFullForm,
  forms: { full: consultationSubmissionFullForm, context: consultationSubmissionContextForm, mini: consultationSubmissionMiniForm, lookup: consultationSubmissionLookupForm },
  menu: consultationSubmissionMenu,
} as IRecordTypeDefinition;
